import { render } from "./TopicVoting.vue?vue&type=template&id=09be6f50&scoped=true"
import script from "./TopicVoting.vue?vue&type=script&lang=js"
export * from "./TopicVoting.vue?vue&type=script&lang=js"

import "./TopicVoting.vue?vue&type=style&index=0&id=09be6f50&scoped=true&lang=css"

import exportComponent from "C:\\Users\\TimSpule\\source\\repos\\peacoq\\Schaltzeit\\ScoutDB\\CisLogic.ScoutDB.UI.Esa\\app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09be6f50"]])

export default __exports__